export enum Filter {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
